import { useState, useEffect, useRef } from 'react'
import { Input } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker'
import moment from 'moment'
import { element, func, string, object, oneOfType } from 'prop-types'
import { Paper } from '@components'
import { determineCalendarPosition } from './utils'

const CALENDAR_PICKER_HEIGHT = 340

export const DateEdit = props => {
  const { data = null, format, parent, updateData, close } = props
  const calendarPickerPosition = determineCalendarPosition({
    containerElement: parent,
    calendarHeight: CALENDAR_PICKER_HEIGHT,
  })

  const [newValue, setNewValue] = useState(data || '')
  const inputRef = useRef(null)

  const formattedDateValue = moment(newValue, format).utc()
  const isPropsDateValid = formattedDateValue.isValid()
  const validDate = isPropsDateValid ? formattedDateValue : moment(new Date(), format).utc()

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const checkForEnter = e => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      e.preventDefault()
      updateData(newValue)
      close(true)
    }
    if (e.key === 'Escape') {
      e.stopPropagation()
      e.preventDefault()
      updateData(data)
      close()
    }
    if (e.key === 'Tab') {
      e.stopPropagation()
      e.preventDefault()
      updateData(newValue)
      close('TAB')
    }
  }

  const updateDate = date => {
    const formattedDate = moment(date).utc().format(format)
    updateData(formattedDate)
    close()
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Input
        ref={inputRef}
        autoFocus
        disableUnderline
        onChange={e => setNewValue(e.target.value)}
        onKeyDown={checkForEnter}
        placeholder={format}
        sx={{
          height: parent.clientHeight,
          fontSize: 12.25,
          boxSizing: 'border-box',
          width: '100%',
          backgroundColor: 'white',
          position: 'relative',
          paddingLeft: '4px',
          paddingRight: '4px',
          border: '1px solid #25515B',
        }}
        value={newValue}
      />
      <div
        style={{
          position: 'absolute',
          width: '325px',
          ...calendarPickerPosition,
        }}
      >
        <Paper elevation={5}>
          <CalendarPicker date={validDate} onChange={updateDate} />
        </Paper>
      </div>
    </LocalizationProvider>
  )
}

DateEdit.propTypes = {
  data: string || null,
  updateData: func.isRequired,
  close: func.isRequired,
  parent: oneOfType([element, object]).isRequired,
  format: string.isRequired,
}
